
{
  "familyId": "STU-CIRKEL",
  "questions": [
    {
      "id": "STU-CIRKEL-001",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "pie_chart",
      "question": "Bekijk het cirkeldiagram. Welk vervoermiddel gebruiken de meeste leerlingen?",
      "context": null,
      "options": ["Fiets", "Auto", "Bus", "Lopen"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Fiets", "Auto", "Bus", "Lopen"],
        "values": [45, 20, 15, 20],
        "title": "Vervoer naar school",
        "correctIndex": 0
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Cirkeldiagram lezen", "content": "Het grootste deel van de cirkel hoort bij de hoogste waarde. Fiets (45%) is het grootste deel — de meeste leerlingen fietsen naar school.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "pie_chart_largest_slice",
      "variantIndex": 1,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.83,
      "feedback": {
        "explanationText": "Zoek het grootste deel van de cirkel. Vergelijk de delen: Fiets (45%), Auto (20%), Bus (15%), Lopen (20%). Fiets (45%) is het grootste deel, dus de meeste leerlingen komen met de fiets.",
        "solutionSteps": [
          "Lees de waarden af: Fiets 45%, Auto 20%, Bus 15%, Lopen 20%",
          "Vergelijk: 45% > 20% > 20% > 15%",
          "Fiets (45%) is het grootste deel"
        ],
        "distractorExplanations": {
          "0": "Goed! Fiets (45%) is het grootste deel van het cirkeldiagram.",
          "1": "Je dacht waarschijnlijk dat Auto het grootste deel is. Maar Auto (20%) is kleiner dan Fiets (45%). Onthoud: vergelijk altijd de percentages om het grootste deel te vinden.",
          "2": "Je dacht waarschijnlijk dat Bus het grootste deel is. Maar Bus (15%) is juist het kleinste deel. Onthoud: het grootste deel van de cirkel hoort bij het hoogste percentage.",
          "3": "Je dacht waarschijnlijk dat Lopen het grootste deel is. Maar Lopen (20%) is even groot als Auto, maar kleiner dan Fiets (45%). Onthoud: kijk naar de getallen, niet alleen naar de vorm."
        }
      }
    },
    {
      "id": "STU-CIRKEL-002",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "pie_chart",
      "question": "Een bibliothecaris maakt een overzicht van favoriete boekgenres. Welk genre wordt het minst gelezen? Klik op het juiste deel.",
      "context": null,
      "options": ["Avontuur", "Fantasy", "Wetenschap", "Sport"],
      "correctAnswer": 2,
      "data": {
        "labels": ["Avontuur", "Fantasy", "Wetenschap", "Sport"],
        "values": [35, 30, 10, 25],
        "title": "Favoriete boekgenre",
        "correctIndex": 2
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Kleinste deel zoeken", "content": "Zoek het kleinste deel van de cirkel. Wetenschap (10%) is het kleinste deel — dat genre wordt het minst gelezen.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "pie_chart_smallest_slice",
      "variantIndex": 2,
      "citoDifficulty": 0.17,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Zoek het kleinste deel van de cirkel. Avontuur (35%), Fantasy (30%), Wetenschap (10%), Sport (25%). Wetenschap (10%) is het kleinste deel — dat genre wordt het minst gelezen.",
        "solutionSteps": [
          "Lees de waarden af: Avontuur 35%, Fantasy 30%, Wetenschap 10%, Sport 25%",
          "Vergelijk: 10% < 25% < 30% < 35%",
          "Wetenschap (10%) is het kleinste deel"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat Avontuur het minst gelezen wordt. Maar Avontuur (35%) is juist het grootste deel, niet het kleinste. Onthoud: lees de vraag goed — 'minst' betekent het kleinste percentage.",
          "1": "Je dacht waarschijnlijk dat Fantasy het kleinste deel is. Maar Fantasy (30%) is het op één na grootste deel. Onthoud: vergelijk alle percentages om het kleinste te vinden.",
          "2": "Goed! Wetenschap (10%) is het kleinste deel — dat genre wordt het minst gelezen.",
          "3": "Je dacht waarschijnlijk dat Sport het kleinste deel is. Maar Sport (25%) is groter dan Wetenschap (10%). Onthoud: kijk naar de getallen, niet naar de positie in de lijst."
        }
      }
    },
    {
      "id": "STU-CIRKEL-003",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "multiple_choice",
      "question": "Een schooldirecteur bekijkt een cirkeldiagram: 25% rood, 50% blauw, en 25% groen. Welk deel is precies de helft van de cirkel?",
      "context": null,
      "options": ["Blauw", "Rood", "Groen", "Rood en groen samen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Helft van een cirkel", "content": "De helft van een cirkel = 50%. Blauw is 50%, dus blauw is precies de helft. Let op: rood en groen samen zijn ook 50% (25% + 25%).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "pie_chart_half",
      "variantIndex": 3,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "De helft van een cirkel = 50%. Rood = 25%, Blauw = 50%, Groen = 25%. Blauw (50%) is precies de helft. Let op: rood + groen = 25% + 25% = 50% is ook de helft, maar de vraag vraagt welk deel (enkelvoud).",
        "solutionSteps": [
          "De helft van een cirkel = 50%",
          "Lees de waarden: Rood 25%, Blauw 50%, Groen 25%",
          "Blauw (50%) is precies de helft"
        ],
        "distractorExplanations": {
          "0": "Goed! Blauw (50%) is precies de helft van de cirkel.",
          "1": "Je dacht waarschijnlijk dat 25% de helft is. Maar Rood (25%) is een kwart, niet de helft. Onthoud: de helft = 50%, een kwart = 25%.",
          "2": "Je dacht waarschijnlijk dat 25% de helft is. Maar Groen (25%) is een kwart, niet de helft. Onthoud: de helft = 50%, een kwart = 25%.",
          "3": "Je dacht waarschijnlijk dat je twee delen moet combineren. Rood en groen samen zijn ook 50%, maar de vraag vraagt naar één deel. Onthoud: Blauw alleen is al de helft."
        }
      }
    },
    {
      "id": "STU-CIRKEL-004",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "pie_chart",
      "question": "Een gymleraar ondervraagt 200 leerlingen over hun favoriete sport. Klik op het deel dat ongeveer 80 leerlingen vertegenwoordigt.",
      "context": null,
      "options": ["Voetbal", "Zwemmen", "Dansen", "Turnen"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Voetbal", "Zwemmen", "Dansen", "Turnen"],
        "values": [40, 25, 20, 15],
        "title": "Favoriete sport (200 leerlingen)",
        "correctIndex": 0
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Percentage naar aantal", "content": "80 van 200 leerlingen = 80 ÷ 200 × 100 = 40%. Voetbal is 40% — dat zijn 80 leerlingen.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "pie_chart_percentage_to_count",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Reken het aantal om naar een percentage. 80 van 200 = 80 ÷ 200 = 0,40 = 40%. Zoek het deel met 40%: Voetbal. Voetbal (40%) vertegenwoordigt 80 leerlingen.",
        "solutionSteps": [
          "Reken het aantal om: 80 ÷ 200 = 0,40 = 40%",
          "Zoek het deel met 40% in het diagram",
          "Voetbal = 40% → dat zijn 80 leerlingen"
        ],
        "distractorExplanations": {
          "0": "Goed! 40% van 200 = 80 leerlingen. Voetbal is 40%.",
          "1": "Je dacht waarschijnlijk dat Zwemmen 80 leerlingen vertegenwoordigt. Maar Zwemmen (25%) = 25% × 200 = 50 leerlingen, niet 80. Onthoud: reken het percentage om naar een aantal: percentage × totaal.",
          "2": "Je dacht waarschijnlijk dat Dansen 80 leerlingen vertegenwoordigt. Maar Dansen (20%) = 20% × 200 = 40 leerlingen, niet 80. Onthoud: 80 van 200 = 40%.",
          "3": "Je dacht waarschijnlijk dat Turnen 80 leerlingen vertegenwoordigt. Maar Turnen (15%) = 15% × 200 = 30 leerlingen, niet 80. Onthoud: 80 van 200 = 40%, en dat is Voetbal."
        }
      }
    },
    {
      "id": "STU-CIRKEL-005",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "multiple_choice",
      "question": "Een fruithandelaar bekijkt een cirkeldiagram: Appels 35%, Peren 25%, Bananen 30%, Sinaasappels 10%. Hoeveel procent meer wordt er aan appels verkocht dan aan sinaasappels?",
      "context": null,
      "options": ["25%", "35%", "10%", "45%"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Verschil berekenen", "content": "Trek de percentages van elkaar af om het verschil te vinden. Appels (35%) − Sinaasappels (10%) = 25%. Er wordt 25% meer aan appels verkocht.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "pie_chart_difference",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Trek de twee percentages van elkaar af om het verschil te vinden. Appels = 35%, Sinaasappels = 10%. Verschil: 35% − 10% = 25%. Er wordt 25% meer aan appels verkocht dan aan sinaasappels.",
        "solutionSteps": [
          "Lees de waarden af: Appels = 35%, Sinaasappels = 10%",
          "Bereken het verschil: 35% − 10% = 25%",
          "Er wordt 25% meer aan appels verkocht",
          "Check: 10% + 25% = 35% ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 35% − 10% = 25% meer appels dan sinaasappels.",
          "1": "Je dacht waarschijnlijk dat het antwoord het percentage van appels zelf is. Maar 35% is het aandeel van appels, niet het verschil. Onthoud: het verschil bereken je door af te trekken: 35% − 10% = 25%.",
          "2": "Je dacht waarschijnlijk dat het antwoord het percentage van sinaasappels is. Maar 10% is het aandeel van sinaasappels, niet het verschil. Onthoud: 'hoeveel meer' = aftrekken: 35% − 10% = 25%.",
          "3": "Je dacht waarschijnlijk dat je de percentages moet optellen. Maar 35% + 10% = 45% is de som, niet het verschil. Onthoud: 'hoeveel meer' = aftrekken, niet optellen."
        }
      }
    }
  ]
}
